<template>
  <v-card class="info-page rounded-xl bg-surface border border-white-05 pa-8 mb-10">
    <div class="text-h3 font-weight-black mb-6 text-primary">What is Gamedev.id?</div>
    
    <div class="text-h5 font-weight-bold mb-4">A Community Hub for Game Developers</div>
    <p class="text-body-1 text-grey-lighten-1 mb-8">
      Gamedev.id is a specialized platform built on the <strong class="text-white">AT Protocol (Bluesky)</strong> designed specifically for the game development community. 
      It's not just another social network; it's a dedicated workspace for developers to showcase their craft, discover peers, and engage in meaningful technical discussions.
    </p>

    <v-row class="mb-8">
      <v-col cols="12" md="6">
        <v-card variant="tonal" border class="pa-6 rounded-lg h-100">
          <v-icon icon="mdi-account-details" color="primary" size="large" class="mb-2"></v-icon>
          <div class="text-h6 font-weight-bold mb-2">Native Portfolios</div>
          <p class="text-body-2 text-grey">
            Transform your Bluesky profile into a professional portfolio. Highlight your Ludography, work experience, and technical skills directly on-chain.
          </p>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card variant="tonal" border class="pa-6 rounded-lg h-100">
          <v-icon icon="mdi-fountain-pen-tip" color="primary" size="large" class="mb-2"></v-icon>
          <div class="text-h6 font-weight-bold mb-2">Writer Mode</div>
          <p class="text-body-2 text-grey">
            Write long-form devlogs and articles with rich media support. Share your journey and insights without the character limits of standard posts.
          </p>
        </v-card>
      </v-col>
    </v-row>

    <div class="text-h5 font-weight-bold mb-4">Powered by AT Protocol</div>
    <p class="text-body-1 text-grey-lighten-1 mb-6">
      Because we are built on the AT Protocol, your data is yours. Your follows, posts, and interactions are shared across the entire Bluesky network. 
      Login with your existing account and your community is already here.
    </p>

    <v-btn color="primary" size="large" rounded="pill" class="text-none font-weight-black px-8" @click="$emit('back')">
      Return to Feed
    </v-btn>
  </v-card>
</template>

<script setup lang="ts">
defineEmits(['back']);
</script>

<style scoped>
.info-page {
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.6;
}
</style>
